"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareData = exports.initiateDatabase = exports.DATA_BASES = void 0;
const uuid_1 = require("@lukeed/uuid");
const nmr_processing_1 = require("nmr-processing");
const full_1 = __importDefault(require("openchemlib/full"));
const openchemlib_utils_1 = require("openchemlib-utils");
const smart_array_filter_1 = require("smart-array-filter");
exports.DATA_BASES = [
    {
        key: 'local_solvent',
        label: 'Solvent database',
        value: prepareDataBase([...nmr_processing_1.protonImpurities, ...nmr_processing_1.carbonImpurities]),
    },
];
function initiateDatabase(databases, nucleus) {
    const data = databases.filter((datum) => datum.nucleus === nucleus);
    const moleculesDB = prepareMoleculesDB(data);
    const getSolvents = () => prepareGetSolvents(data);
    const search = ({ idCode = '', keywords = '', }) => prepareSearch({ idCode, keywords, data, moleculesDB });
    return { data, getSolvents, search };
}
exports.initiateDatabase = initiateDatabase;
function prepareSearch(options) {
    const { data, keywords = [], moleculesDB, idCode } = options;
    let searchData = data;
    if (idCode) {
        searchData = processSearchByStructure(moleculesDB, idCode);
    }
    return (0, smart_array_filter_1.filter)(searchData, { keywords });
}
function processSearchByStructure(moleculesDB, idCode) {
    // default format { format: 'idCode' }
    // https://github.com/cheminfo/openchemlib-utils/blob/ef3a9c30be7efe225a24de04ea9cefc9299674aa/src/db/MoleculesDB.js#L102-L115
    // todo: idCode may be null and the current version of search requires a string or molecule. `|| ''` will become useless in next release of openchemlib-util
    const result = moleculesDB.search(idCode || '');
    return result.map((entry) => entry.data);
}
function prepareGetSolvents(data) {
    const result = [];
    const map = new Map();
    for (const item of data) {
        if (!map.has(item.solvent)) {
            map.set(item.solvent, true);
            result.push(item.solvent);
        }
    }
    return result;
}
// export function getDatabasesNames() {
//   return databases.map((database, index) => {
//     const { label } = database;
//     return { id: index, name: label };
//   });
// }
function prepareMoleculesDB(array) {
    const moleculesDB = new openchemlib_utils_1.MoleculesDB(full_1.default);
    for (const entry of array) {
        if (entry.ocl) {
            try {
                const molecule = full_1.default.Molecule.fromIDCode(entry.ocl.idCode, entry.ocl.coordinates);
                moleculesDB.pushEntry(molecule, entry, {
                    idCode: entry.ocl.idCode,
                    index: entry.ocl.index,
                });
            }
            catch {
                // eslint-disable-next-line no-console
                console.error(`Could not parse idCode: ${JSON.stringify(entry.ocl)}`);
            }
        }
        else if (entry.smiles) {
            try {
                const molecule = full_1.default.Molecule.fromSmiles(entry.smiles);
                moleculesDB.pushEntry(molecule, entry);
            }
            catch {
                // eslint-disable-next-line no-console
                console.error(`Could not parse smiles: ${entry.smiles}`);
            }
        }
    }
    return moleculesDB;
}
function prepareDataBase(array) {
    return array.map((item) => {
        item.ranges = item.ranges.map((range) => ({
            id: (0, uuid_1.v4)(),
            ...range,
        }));
        return item;
    });
}
function prepareData(data) {
    const result = [];
    let index = 0;
    for (const item of data) {
        const ids = [];
        const { ranges, ...restItemKeys } = item;
        if (!ranges) {
            ids.push((0, uuid_1.v4)());
            result.push({
                ...restItemKeys,
                index,
                id: ids,
                ranges: [],
            });
        }
        else {
            for (const range of ranges) {
                ids.push(range.id || (0, uuid_1.v4)());
                const { signals = [], ...restRangKeys } = range;
                for (const signal of signals) {
                    const { js = [], ...restSignalKeys } = signal;
                    const jsResult = mapJs(js);
                    const data = {
                        ...restItemKeys,
                        ...restRangKeys,
                        ...restSignalKeys,
                        ...jsResult,
                        index,
                        id: ids,
                        ranges,
                    };
                    result.push(data);
                }
            }
        }
        index++;
    }
    return result;
}
exports.prepareData = prepareData;
function mapJs(js) {
    if (js && js.length > 0) {
        const result = {
            coupling: [],
            multiplicity: '',
        };
        for (const { coupling, multiplicity } of js) {
            result.coupling.push(coupling);
            result.multiplicity += multiplicity || '';
        }
        const { coupling, multiplicity } = result;
        if (multiplicity.length === 0)
            return { coupling: coupling.join(',') };
        return { multiplicity, coupling: coupling.join(',') };
    }
    else {
        return { coupling: '' };
    }
}
